module.exports = __webpack_public_path__ + "img/Glosario.2f5d48f9.svg";